// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__1OaNv","button":"Pagination_button__k9xnQ"};